export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Rechnungsdaten",
    requeridos: "Die Rechnungsdaten sind erforderlich",
  },
  perfil: {
    swalTitle: "Prüfen Sie Ihre E-Mails",
    swalText:
      "Um Ihr Passwort weiter zu ändern, sehen Sie in Ihrem Posteingang nach und folgen Sie den Schritten",
    swalConfirm: "Weiter",
    errorInesperado: "Ups! Es ist ein unerwarteter Fehler aufgetreten",
  },
  facturacionCuenta: {
    editarInfo: "Daten bearbeiten",
    direccionLinea1: "Adresszeile 1",
    direccionLinea2: "Adresszeile 2 (optional)",
    cancelar: "Abbrechen",
    guardando: "Wird gespeichert...",
    guardarCambios: "Änderungen speichern",
    errorCargar: "Fehler beim Laden der Rechnungsdaten",
    actualizadoOk: "Daten erfolgreich aktualisiert",
    errorActualizar: "Fehler beim Aktualisieren",
    errorActualizarDatos: "Fehler beim Aktualisieren der Daten",
  },
};
